import { SET_COUNTRY_CODE } from "../../constants";

import { createAction } from "../../utils";

const setCountryCode = createAction(SET_COUNTRY_CODE);

export const setCountryCodeInSession =
  (countryCode) => (dispatch, getState) => {
    window.sessionStorage.setItem("customerCountryCode", countryCode);

    dispatch(setCountryCode(countryCode));
  };
